import React, { useState } from "react";
import { Outlet, NavLink, useNavigate } from "react-router-dom";
import { Dropdown, Badge } from "react-bootstrap";

import {
  FiMenu,
  FiX,
  FiBell,
  FiLogOut,
  FiUser,
  FiHome,
  FiUsers,
  FiGrid,
  FiSend,
  FiUpload,
  FiFileText,
  FiMessageCircle,
} from "react-icons/fi";
import "./DashboardLayout.css";
import logo from "../assets/logo.png";

function DashboardLayout({ user, setUser }) {
  const navigate = useNavigate();
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);

  const handleLogout = () => {
    localStorage.removeItem("user");
    setUser(null);
    navigate("/");
  };

  const menus = {
    admin: [
      { name: "Dashboard", path: "/dashboard/super-admin/home", icon: <FiHome /> },
      { name: "Contacts", path: "/dashboard/super-admin/contacts-list", icon: <FiUsers /> },
      { name: "Categories", path: "/dashboard/super-admin/category-management", icon: <FiGrid /> },
      { name: "Campaign", path: "/dashboard/super-admin/campaign", icon: <FiSend /> },
      { name: "Import Contacts", path: "/dashboard/super-admin/import-contacts", icon: <FiUpload /> },
      { name: "Messages", path: "/dashboard/super-admin/messages", icon: <FiMessageCircle /> },
      { name: "Activity Logs", path: "/dashboard/super-admin/logs", icon: <FiFileText /> },
    ],
  };

  const menuItems = menus[user?.role] || [];

  return (
    <div className="layout-wrapper">
      {/* TOP BAR */}
      <header className="topbar">
        <button className="menu-toggle" onClick={() => setIsSidebarOpen(!isSidebarOpen)}>
          {isSidebarOpen ? <FiX size={22} /> : <FiMenu size={22} />}
        </button>

        <div className="topbar-title">
          <strong>Admin Panel</strong>
        </div>

        <div className="topbar-actions">
          <FiBell size={18} className="me-3" />

          <Dropdown align="end">
            <Dropdown.Toggle variant="light" size="sm">
              <FiUser /> {user?.name}
            </Dropdown.Toggle>

            <Dropdown.Menu>
              <Dropdown.Item disabled>
                Role: <Badge bg="primary">{user?.role}</Badge>
              </Dropdown.Item>
              <Dropdown.Divider />
              <Dropdown.Item onClick={handleLogout}>
                <FiLogOut className="me-2" /> Logout
              </Dropdown.Item>
            </Dropdown.Menu>
          </Dropdown>
        </div>
      </header>

      {isSidebarOpen && <div className="sidebar-overlay" onClick={() => setIsSidebarOpen(false)} />}

      {/* SIDEBAR */}
    <aside className={`sidebar ${isSidebarOpen ? "open" : ""}`}>
  <div className="sidebar-brand">
    <img src={logo} alt="Logo" />
  </div>
<span className="brand-text">Admin</span>
  <nav className="menu">
    {menuItems.map((item) => (
      <NavLink
        key={item.name}
        to={item.path}
        className={({ isActive }) =>
          `menu-item ${isActive ? "active" : ""}`
        }
        onClick={() => setIsSidebarOpen(false)}
      >
        <span className="menu-icon">{item.icon}</span>
        <span className="menu-label">{item.name}</span>
      </NavLink>
    ))}
  </nav>

  <div className="logout-section">
    <button className="logout-btn" onClick={handleLogout}>
      <FiLogOut size={16} />
      <span>Logout</span>
    </button>
  </div>
</aside>

      {/* CONTENT */}
      <main className="content">
        <Outlet />
      </main>
    </div>
  );
}

export default DashboardLayout;
